export enum SaleUnitCartSplitCheckMethodEnum {
  SPLIT_BY_PRODUCT = 'SPLIT_BY_PRODUCT',
  SPLIT_BY_AMOUNT = 'SPLIT_BY_AMOUNT',
}
